const getters = {
  recharge: state => state.account.recharge,
  balance: state => state.account.balance,
  user: state => state.account.user,
  menu: state => state.account.menu,
  status: state => state.account.status,
  token: state => state.account.token,
  shopTokenuserparam: state => state.cookies.shopTokenuserparam,
  shopTokenapps: state => state.cookies.shopTokenapps,
  shopTokenuser: state => state.cookies.shopTokenuser,
  urlSearch: state => state.cookies.urlSearch
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js